import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import mapValues from 'lodash/mapValues';

import { SuiModal, SuiContainer, SuiModalHeader, SuiModalContent, SuiModalFooter, SuiButton } from '@splashthat/sui';
import { setErrorMessages } from 'common/entities/form';
import { getErrorMessages } from 'common/entities/form/selectors';
import { closeErrorMessageModal } from '../../actions/errorMessage';
import { getIsOpen } from '../../selectors/errorMessage';
import FormErrorMessageEditor from './FormErrorMessageEditor';
import { ErrorMessageHeader, ErrorMessageHeaderDescription, ErrorMessageHeaderTitle } from './FormErrorMessage.styles';
import { getFormId } from '../../selectors';
import { notifySuccess } from '../../../Notification/modules';

const DONE = 'Done';
const CANCEL = 'Cancel';
const HEADER = 'Edit Error Messages';
const HEADER_DESCRIPTION =
    'A guest could see any of these errors on your form when they RSVP. Replace the default text with your own to start customizing your error messages.';
const SUCCESS_SAVE_MESSAGE = 'Custom error messaging saved!';

const FormErrorMessageModal = (props) => {
    const [errorMessageList, setErrorMessageList] = useState(props.errorMessages);

    const setErrorMessage = (errorMessage) => {
        setErrorMessageList({
            ...errorMessageList,
            ...errorMessage,
        });
    };

    const handleSave = () => {
        const trimErrorMessageList = mapValues(errorMessageList, (value) => (value && value.trim()) || null);

        props.setErrorMessages(props.formId, trimErrorMessageList);
        props.closeErrorMessageModal();
        props.notifySuccess(SUCCESS_SAVE_MESSAGE);
    };

    return (
        <SuiModal
            open={props.open}
            size={SuiModal.MEDIUM}
            useClickOutside
            closeOnClickOutside={false}
            onRequestClose={props.closeErrorMessageModal}
        >
            {props.open && (
                <SuiContainer variation="border standard flex-vertical" className="SuiModalContainer">
                    <ErrorMessageHeader>
                        <SuiModalHeader>
                            <SuiContainer variation="flex-vertical flex-inherit">
                                <ErrorMessageHeaderTitle variation="flex-group">
                                    <h2>{HEADER}</h2>
                                </ErrorMessageHeaderTitle>
                                <ErrorMessageHeaderDescription>
                                    <p>{HEADER_DESCRIPTION}</p>
                                </ErrorMessageHeaderDescription>
                            </SuiContainer>
                        </SuiModalHeader>
                    </ErrorMessageHeader>

                    <SuiModalContent>
                        <FormErrorMessageEditor setErrorMessage={setErrorMessage} />
                    </SuiModalContent>

                    <SuiModalFooter>
                        <SuiContainer variation="flex-group">
                            <SuiButton variation="secondary" label={CANCEL} onClick={props.closeErrorMessageModal} />
                        </SuiContainer>
                        <SuiContainer variation="flex-group">
                            <SuiButton label={DONE} onClick={handleSave} />
                        </SuiContainer>
                    </SuiModalFooter>
                </SuiContainer>
            )}
        </SuiModal>
    );
};

FormErrorMessageModal.propTypes = {
    open: PropTypes.bool.isRequired,
    closeErrorMessageModal: PropTypes.func.isRequired,
    formId: PropTypes.string,
    setErrorMessages: PropTypes.func.isRequired,
    errorMessages: PropTypes.object.isRequired,
    notifySuccess: PropTypes.func.isRequired,
};

FormErrorMessageModal.defaultProps = {
    formId: null,
};

const mapStateToProps = (state) => ({
    open: getIsOpen(state),
    formId: getFormId(state),
    errorMessages: getErrorMessages(state, getFormId(state)),
});

const mapDispatchToProps = {
    closeErrorMessageModal,
    setErrorMessages,
    notifySuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormErrorMessageModal);
